module.exports = __webpack_public_path__ + "static/media/GolfBuggy-half.bc0be4b6.png";